import { apiFetch, parseResponse, PUBLIC_ENDPOINTS } from "./config.js";
import { buildProductSearchQuery } from "@/utils/productSearchParams.js";

export async function getStoreInfo() {
    const response = await apiFetch(PUBLIC_ENDPOINTS.STORE_INFO);
    return parseResponse(response);
}

export async function recordPartnerSitePromoClick(advertisementId) {
    const body = JSON.stringify(advertisementId ? { advertisementId } : {});
    const maxAttempts = 3;
    const retryDelayMs = 250;
    let lastError;

    for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        try {
            const response = await apiFetch(PUBLIC_ENDPOINTS.PARTNER_SITE_PROMO_CLICKS, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body
            });
            return await parseResponse(response);
        } catch (err) {
            lastError = err;
            if (attempt < maxAttempts) {
                await new Promise((resolve) => window.setTimeout(resolve, retryDelayMs));
            }
        }
    }

    console.warn(
        "[storefront] partner promo click metric failed after 3 attempts; giving up",
        { advertisementId, error: lastError }
    );
}

export async function searchProducts(filters, page = 0) {
    const params = buildProductSearchQuery(filters, page);
    const response = await apiFetch(`${PUBLIC_ENDPOINTS.PRODUCTS}?${params}`);
    return parseResponse(response);
}

export async function searchNewlyPublishedProducts(page = 0, seed) {
    const params = new URLSearchParams({ offset: String(page) });
    if (seed) {
        params.set("seed", seed);
    }
    const response = await apiFetch(`${PUBLIC_ENDPOINTS.PRODUCTS_NEW}?${params}`);
    return parseResponse(response);
}

export async function searchRestockedProducts(page = 0, seed) {
    const params = new URLSearchParams({ offset: String(page) });
    if (seed) {
        params.set("seed", seed);
    }
    const response = await apiFetch(`${PUBLIC_ENDPOINTS.PRODUCTS_RESTOCKED}?${params}`);
    return parseResponse(response);
}

export async function getProductHighlightAvailability() {
    const response = await apiFetch(PUBLIC_ENDPOINTS.PRODUCT_HIGHLIGHT_AVAILABILITY);
    return parseResponse(response);
}

export async function getProduct(productId) {
    const response = await apiFetch(PUBLIC_ENDPOINTS.PRODUCT(productId));
    return parseResponse(response);
}

export async function getProductHighlight() {
    const response = await apiFetch(PUBLIC_ENDPOINTS.PRODUCT_HIGHLIGHT);
    return parseResponse(response);
}

export async function getProductHighlightStrips() {
    const response = await apiFetch(PUBLIC_ENDPOINTS.PRODUCT_HIGHLIGHT_STRIPS);
    return parseResponse(response);
}

export async function getProductReviews(productId, { sort = "GRADE_DESC", page = 0, size = 20 } = {}) {
    const params = new URLSearchParams({
        sort,
        page: String(page),
        size: String(size)
    });
    const response = await apiFetch(`${PUBLIC_ENDPOINTS.PRODUCT_REVIEWS(productId)}?${params}`);
    return parseResponse(response);
}

export async function getCategories() {
    const response = await apiFetch(PUBLIC_ENDPOINTS.CATEGORIES);
    return parseResponse(response);
}

export async function getCountries() {
    const response = await apiFetch(PUBLIC_ENDPOINTS.COUNTRIES);
    return parseResponse(response);
}

export function getFileUrl(fileId) {
    return fileId ? PUBLIC_ENDPOINTS.FILE(fileId) : null;
}

export async function login(payload) {
    const response = await apiFetch(PUBLIC_ENDPOINTS.LOGIN, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    });
    return parseResponse(response);
}

export async function register(payload) {
    const response = await apiFetch(PUBLIC_ENDPOINTS.REGISTER, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    });
    return parseResponse(response);
}
